<div class="drawer-overlay app-overlay" [class.open]="isOpen" [style.opacity]="isOpen ? 1 : 0" [style.visibility]="isOpen ? 'visible' : 'hidden'" (click)="onClose()"></div>

<div class="notification-drawer" [class.open]="isOpen" role="dialog" aria-modal="true" aria-label="Notifications">
  <div class="drawer-header">
    <div class="header-title">
      <h2>Notifications</h2>
      <span class="badge" *ngIf="notifications.length > 0">{{ notifications.length }} New</span>
    </div>
    <button class="close-btn" (click)="onClose()" aria-label="Close notifications">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <!-- <div class="drawer-actions" *ngIf="notifications.length > 0">
    <button (click)="markAllAsRead()">Mark all as read</button>
    <button (click)="clearAll()">Clear all</button>
  </div> -->

  <div class="drawer-content">
    <div *ngIf="isLoading" class="p-4 text-center">
      <p style="color: var(--text-muted)">Loading notifications...</p>
    </div>

    <div *ngIf="!isLoading && notifications.length === 0" class="empty-state">
      <div class="empty-icon">
        <svg
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      </div>
      <p>No new notifications</p>
      <span>You're all caught up!</span>
    </div>

    <div class="notification-list" *ngIf="notifications.length > 0">
      <div
        *ngFor="let notification of notifications"
        class="notification-item"
        [class.unread]="!notification.read && !notification.is_read"
        [class.success]="notification.type === 'success'"
        [class.warning]="notification.type === 'warning'"
        [class.info]="notification.type === 'info'"
        [class.followup]="
          notification.type === 'followup' || notification.type === 'followup_reminder'
        "
        role="button" tabindex="0" [attr.aria-label]="notification.title"
        (click)="handleNotificationClick(notification)"
        (keydown.enter)="handleNotificationClick(notification)"
        (keydown.space)="$event.preventDefault(); handleNotificationClick(notification)"
      >
        <div class="notification-body">
          <div class="notification-header">
            <span class="notification-title">{{ notification.title }}</span>
            <span class="notification-time">{{
              notification.time || getTimeAgo(notification.created_at)
            }}</span>
          </div>
          <p class="notification-message">{{ notification.message }}</p>
          <div
            *ngIf="notification.type === 'followup_reminder' || notification.type === 'followup'"
            class="notification-badge"
          >
            <span class="text-xs text-blue-600 font-medium">📅 Follow-up</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
